/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Sent_TitleInputs */

const en_guest_book_sent_title = /** @type {(inputs: Guest_Book_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your inbox`)
};

const pl_guest_book_sent_title = /** @type {(inputs: Guest_Book_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź skrzynkę`)
};

/**
* | output |
* | --- |
* | "Check your inbox" |
*
* @param {Guest_Book_Sent_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_sent_title = /** @type {((inputs?: Guest_Book_Sent_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Sent_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_sent_title(inputs)
	return en_guest_book_sent_title(inputs)
});